/* QubCommon Imports */
import ToolbarExplorer from "qubCommon/ExplorerToolbar";
import Dropdown from "qubCommon/Inputs/Dropdown";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";

/* Other project imports */
import ButtonProvoli from "components/Buttons/ButtonProvoli";

/* APIs */

import { menuKeyOrdersExpl } from "api/MenuKeys";

/* React, MUI, Redux, react-hook-forms */
import { Grid, Box, Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";
import format from "date-fns/format";
import React, { useState, useEffect } from "react";

/*Wijmo Imports*/
import { FlexGrid } from "@grapecity/wijmo.react.grid";
import { AllowResizing } from "@grapecity/wijmo.grid";
import useOrdersExplorer from "./useOrdersExplorer";

/* CSS */
import "./index.css";
import DateTimeInput from "qubCommon/Inputs/DateTimeInput";
import QubGenGrid from "qubCommon/Grids/QubGenGrid";
import QubGroupGrid from "qubCommon/Grids/QubGroupGrid";
import TextInput from "qubCommon/Inputs/TextInput";

const OrdersExplorer = () => {
  const [gridColumns, setGridColumns] = useState([]);

  const {
    toolbarRef,
    gridRef,
    gridData,
    gridInitialized,
    gridLoadedRows,
    onSubmit,
    excelHandleClick,
    form,
    explParams,
    handleSubmit,
    rowData,
    setRowData,
    rowDialog,
    setRowDialog,
  } = useOrdersExplorer();

  const {
    csvFiles,
    pdfFiles,
    excelFiles,
    columns,
    // criteriaRef,
    // critParams,
    status,
  } = useToolbarProps({ webPageKey: "eShop-Orders-Expl" });

  const toolbarProps = { csvFiles, pdfFiles, excelFiles, columns };

  useEffect(() => {
    const helpCols = [];

    if (Array.isArray(columns) && columns?.length > 0) {
      columns.forEach((column) =>
        column.children.forEach((child) =>
          helpCols.push({
            binding: child.fldName,
            header: child.fldTitle,
            visible: child.isVisible,
            format: child.fldFormat,
          })
        )
      );
      setGridColumns(helpCols);
    } else setGridColumns([]);
  }, [columns]);

  const submit = () => handleSubmit(onSubmit)();
  console.log(explParams);
  console.log(gridData?.items, "debugHere");

  return (
    <>
      <FormProvider {...form}>
        <Grid container sx={{ paddingLeft: 2, paddingRight: 2 }}>
          <Grid container item xs={12}>
            <ToolbarExplorer
              webPageKey={menuKeyOrdersExpl}
              excelHandleClick={excelHandleClick}
              gridRef={gridRef}
              ref={toolbarRef}
              form={form}
              toolbarProps={toolbarProps}
              title={"Αρχεία Καταγραφής"}
            />
          </Grid>
          <Grid
            container
            spacing={2}
            flexDirection="row"
            sx={{ display: "flex", padding: 2, gap: 2 }}
          >
            <DateTimeInput
              name="dateFrom"
              sx={{ width: 200 }}
              label="Απο Ημ/νία"
              defaultDate={format(new Date(), "yyyy-MM-dd")}
              defaultTime="0:00"
            />
            <DateTimeInput
              defaultDate={format(new Date(), "yyyy-MM-dd")}
              name="dateTo"
              sx={{ width: 200 }}
              label="Εως Ημ/νία"
              defaultTime="23:59"
            />
            <TextInput name="searchValue" label="Αρ. Παραγγελίας" />
            {explParams?.Status && (
              <Dropdown
                name="Status"
                label="Κατάσταση"
                options={explParams?.Status}
                defaultValue={explParams?.SelectedValueStatus}
              />
            )}
            {explParams?.Type && (
              <Dropdown
                name="Type"
                label="Τύπος"
                options={explParams?.Type}
                defaultValue={explParams?.SelectedValueType}
              />
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <ButtonProvoli handleClick={submit} />
            </Box>
          </Grid>
        </Grid>
        {/* <QubGenGrid
          id="theGrid"
          style={{ height: "99%" }}
          initialized={gridInitialized}
          loadedRows={gridLoadedRows}
          gridData={gridData?.items}
          columns={gridColumns}
          className="explorer-grid"
        /> */}
        <QubGroupGrid
          id="theGrid"
          style={{ height: "99%" }}
          initialized={gridInitialized}
          loadedRows={gridLoadedRows}
          gridData={gridData?.items}
          columns={columns}
        />
      </FormProvider>
    </>
  );
};

export default OrdersExplorer;
